var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUptime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uptime",
    transform: "translate(-491 -223)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_815",
    "data-name": "Rectangle 815",
    width: 60,
    height: 60,
    rx: 5,
    transform: "translate(491 223)",
    fill: "#f4f5fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8_clock_arrow",
    d: "M22,4A18.021,18.021,0,0,0,4,22v.45a1.35,1.35,0,1,0,2.7,0V22a15.3,15.3,0,1,1,30.6,0v.45a1.35,1.35,0,1,0,2.7,0V22A18.021,18.021,0,0,0,22,4Zm-.471,7.181A1.35,1.35,0,0,0,20.2,12.55v9.9a1.35,1.35,0,0,0,1.35,1.35h7.2a1.35,1.35,0,1,0,0-2.7H22.9V12.55a1.35,1.35,0,0,0-1.371-1.369Zm-15.07,15.3a1.35,1.35,0,0,0-1.281,1.849A17.976,17.976,0,0,0,37.3,31.478V34.15a1.35,1.35,0,1,0,2.7,0v-6.3a1.35,1.35,0,0,0-1.35-1.35h-6.3a1.35,1.35,0,1,0,0,2.7h3.161q-.03.045-.056.091A15.281,15.281,0,0,1,7.7,27.368,1.35,1.35,0,0,0,6.459,26.482Z",
    transform: "translate(499 231)",
    fill: "#325ae7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUptime);
export default __webpack_public_path__ + "static/media/uptime.1f894c83a3c46cbddd0397b6eac4c1c4.svg";
export { ForwardRef as ReactComponent };